import classNames from "classnames";
import React from "react";

import { CollectionResourceType } from "@/shared/domain/collections";

import styles from "./CollectionTypeChip.module.css";

interface CollectionTypeChipProps {
  resourceType: CollectionResourceType;
}

export const CollectionTypeChip: React.FC<CollectionTypeChipProps> = ({
  resourceType,
}) => {
  let backgroundColorClass;
  switch (resourceType) {
    case "file":
      backgroundColorClass = styles.fileBackgroundColor;
      break;
    case "dataset":
      backgroundColorClass = styles.datasetBackgroundColor;
      break;
    case "event":
      backgroundColorClass = styles.eventBackgroundColor;
      break;
    default:
      backgroundColorClass = styles.fileBackgroundColor;
  }

  return (
    <span className={classNames(styles.chip, backgroundColorClass)}>
      {resourceType[0].toUpperCase() + resourceType.slice(1) + "s"}
    </span>
  );
};
